export const HERO_CONSTANTS = {
  button: {
    label: "Simulate and improve your network today",
    link: "#contact-us",
  },
  title: "Virtual Network Simulations for Performance & Security",
};
